// Lib
import React, { useCallback, useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';

// Components
import Input from '../../../Field/Input';

// Validation Schema
import { editApproveQtySchema } from '../../../../validationSchema';

import { useStyles } from './QtyInputStyles';

const QtyInput = ({
  value,
  label,
  onChange = () => {},
  orderLimit,
  setOrderQtyError = () => {},
}) => {
  const { classes } = useStyles();

  const {
    control,
    formState: { errors },
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(editApproveQtySchema),
    defaultValues: {
      orderQty: value,
    },
  });

  useEffect(() => {
    setOrderQtyError(errors?.orderQty?.message);
  }, [errors?.orderQty, setOrderQtyError]);

  const onChangeInput = useCallback(
    (onChangeField) =>
      ({ value }) => {
        if (value && value == 0) return;
        if (value > orderLimit) {
          onChangeField(orderLimit);
          onChange(orderLimit);
        } else {
          onChangeField(value);
          onChange(value);
        }
      },
    [onChange, orderLimit],
  );

  return (
    <Controller
      name="orderQty"
      control={control}
      render={({ field }) => (
        <Input
          {...field}
          autoFocus={true}
          value={value}
          className={classes.input}
          label={label}
          onChange={onChangeInput(field.onChange)}
          error={errors?.orderQty?.message}
        />
      )}
    />
  );
};

export default QtyInput;
